import { inherits as _inherits, createClass as _createClass, defineProperty as _defineProperty, objectWithoutProperties as _objectWithoutProperties, extends as _extends, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import debounce from 'lodash/debounce.js';
import isNil from 'lodash/isNil.js';
import { TYPE_TEXT } from '../../../constants/index.js';
import { GetValidationPattern, isEqualLowerCase } from '../../../utils/ValidationUtil.js';
import { i18n } from '../../../i18n/translate.js';
import { formatClassName as _formatClassName } from '../../../utils/formatClassName.js';
var _excluded = ["activeLanguage", "as", "className", "dataValue", "disableSubmit", "languages", "onValueChange", "runValidation", "scrollContainerId", "valueChangeDelay"];
var FormControl = /*#__PURE__*/function (_React$Component) {
  function FormControl(props) {
    var _this;
    _classCallCheck(this, FormControl);
    _this = _callSuper(this, FormControl, [props]);
    _this.isValid = _this.isValid.bind(_this);
    _this.checkError = _this.checkError.bind(_this);
    _this.onChange = _this.onChange.bind(_this);
    _this.onFormChange = _this.onFormChange.bind(_this);
    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
    _this.debouncedValueChange = debounce(_this.debouncedValueChange.bind(_this), _this.props.valueChangeDelay, {
      leading: false,
      trailing: true
    });
    _this.onBlur = _this.onBlur.bind(_this);
    _this.onFocus = _this.onFocus.bind(_this);
    _this.state = {
      value: !isNil(props.dataValue) ? props.dataValue : ''
    };
    _this.pattern = GetValidationPattern(props.type, props.pattern);
    return _this;
  }
  _inherits(FormControl, _React$Component);
  return _createClass(FormControl, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.valueOverride && this.props.dataValue !== prevProps.dataValue) {
        this.onChange(this.props.dataValue, true);
      }
      if (prevProps.pattern !== this.props.pattern) {
        this.pattern = GetValidationPattern(this.props.type, this.props.pattern);
      }
    }
  }, {
    key: "onFormChange",
    value: function onFormChange(e) {
      this.onChange(e.currentTarget.value);
    }
  }, {
    key: "onChange",
    value: function onChange(value, skipValueChange) {
      if (typeof this.props.onChange === 'function') {
        this.props.onChange(value);
      }
      if (!skipValueChange) {
        this.debouncedValueChange(value);
      }
      this.setState({
        value: value
      });
    }
  }, {
    key: "isValid",
    value: function isValid() {
      if (this.props.isValid && typeof this.props.isValid === 'function') {
        if (!this.props.isValid()) {
          this.input.setCustomValidity(i18n.t('Please enter a valid value'));
        } else {
          this.input.setCustomValidity('');
        }
        return this.props.isValid();
      }
      return this.input.validity.valid;
    }
  }, {
    key: "onBlur",
    value: function onBlur(e) {
      var _e$currentTarget;
      if (typeof this.props.onBlur === 'function') {
        this.props.onBlur(this.state.value);
      }
      this.checkError();
      if (!(e !== null && e !== void 0 && (_e$currentTarget = e.currentTarget) !== null && _e$currentTarget !== void 0 && _e$currentTarget.value)) return;
      if (e.currentTarget.value !== this.props.dataValue) {
        if (typeof this.props.onValueChange === 'function') {
          this.props.onValueChange(_defineProperty({}, this.props.name, e.currentTarget.value));
        }
        this.debouncedValueChange.cancel();
      }
    }
  }, {
    key: "debouncedValueChange",
    value: function debouncedValueChange(value) {
      if (typeof this.props.onValueChange === 'function') {
        this.props.onValueChange(_defineProperty({}, this.props.name, value));
      }
    }
  }, {
    key: "onFocus",
    value: function onFocus() {
      if (typeof this.props.onFocus === 'function') {
        this.props.onFocus();
      }
    }
  }, {
    key: "checkError",
    value: function checkError() {
      if (this.input) {
        var message = null;
        var isValid = this.isValid();
        if (this.input.validity.valueMissing) {
          message = i18n.t('This field is required');
        } else if (!this.input.validity.valid) {
          message = this.input.validationMessage;
        }
        if (this.input.required && isEqualLowerCase(this.props.type, TYPE_TEXT) && this.state.value.trim().length === 0) {
          this.props.setError(true, i18n.t('This field is required'));
          return;
        }
        if (!message && this.props.type && this.props.type.toLowerCase() === 'email') {
          var pattern = new RegExp(GetValidationPattern(this.props.type));
          if (!pattern.test(this.state.value)) {
            message = i18n.t('The email you entered is invalid');
          }
        }
        if (typeof this.props.setError === 'function') {
          this.props.setError(!isValid, message);
        }
      }
    }
  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(e) {
      if (this.props.disableSubmit && e.key === 'Enter') {
        e.preventDefault();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props;
      _this$props.activeLanguage;
      var as = _this$props.as,
        className = _this$props.className;
      _this$props.dataValue;
      _this$props.disableSubmit;
      _this$props.languages;
      _this$props.onValueChange;
      _this$props.runValidation;
      _this$props.scrollContainerId;
      _this$props.valueChangeDelay;
      var props = _objectWithoutProperties(_this$props, _excluded);
      var newClassName = _formatClassName([className, {
        'p-r-10': as === 'textarea'
      }]);
      return /*#__PURE__*/React.createElement(Form.Control, _extends({}, props, {
        as: as,
        className: newClassName,
        "data-field": "input-field",
        onBlur: this.onBlur,
        onChange: this.onFormChange,
        onFocus: this.onFocus,
        onKeyPress: this.handleKeyPress,
        pattern: this.pattern,
        ref: function ref(input) {
          return _this2.input = input;
        },
        value: this.state.value
      }));
    }
  }]);
}(React.Component);
_defineProperty(FormControl, "propTypes", {
  activeLanguage: PropTypes.any,
  caption: PropTypes.string,
  className: PropTypes.string,
  as: PropTypes.string,
  dataValue: PropTypes.any,
  disableSubmit: PropTypes.bool,
  errorMessage: PropTypes.string,
  languages: PropTypes.any,
  max: PropTypes.string,
  min: PropTypes.string,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onValueChange: PropTypes.func,
  pattern: PropTypes.string,
  required: PropTypes.bool,
  runValidation: PropTypes.any,
  scrollContainerId: PropTypes.string,
  searchField: PropTypes.any,
  setError: PropTypes.func,
  type: PropTypes.string,
  valueChangeDelay: PropTypes.number,
  valueOverride: PropTypes.bool
});
_defineProperty(FormControl, "defaultProps", {
  valueChangeDelay: 1000
});
FormControl.displayName = "FormControl";
export { FormControl };